// Page width for form surfaces (z8nrz7e05f): a form fills the viewport, less
// one gutter on each side, with no max-width.

/** The gutter: 24px on each side. A literal class so Tailwind's JIT compiler emits it. */
export const FORM_PAGE_GUTTER_CLASS = 'px-6'
